import { FC, ReactNode } from "react";
import { RightAdornment, Title, Wrapper } from "./LabelNavigation.styled";
import { MessageDescriptor } from "@lingui/core";
import { useLingui } from "@lingui/react";
import { msg } from "@lingui/macro";

interface Props {
  className?: string;
  label?: MessageDescriptor;
  leftAdornment?: ReactNode;
  rightAdornment?: ReactNode;
  onClick?: () => void;
}

const LabelNavigation: FC<Props> = ({
  label = msg``,
  leftAdornment,
  rightAdornment,
  onClick,
}) => {
  const { _ } = useLingui();
  return (
    <Wrapper onClick={onClick}>
      {leftAdornment}
      <Title fontSize={3}>{_(label)}</Title>
      {rightAdornment && <RightAdornment>{rightAdornment}</RightAdornment>}
    </Wrapper>
  );
};

export default LabelNavigation;
